import { create } from "zustand";

import type { AddByHandDraft } from "../api/types";

interface DraftState {
  /** A pre-filled "add by hand" form the agent sent (point_to with a form draft). */
  draft: AddByHandDraft | null;
  /** Who filled the draft when it was not the agent (the name of the screen), else null. */
  origin: string | null;
  set(draft: AddByHandDraft, origin?: string): void;
  clear(): void;
}

/**
 * The agent may fill the add-by-hand form for an item, a component kind or a document kind. The
 * person reviews, changes and sends it; the agent never sends it (DEC-1016-90). The form route
 * reads the draft from here when it opens and clears it once the form has taken it.
 */
export const useDraftStore = create<DraftState>((set) => ({
  draft: null,
  origin: null,
  set: (draft, origin) => set({ draft, origin: origin ?? null }),
  // The origin stays until the next draft is set: the form that took the draft reads it after the store is cleared.
  clear: () => set({ draft: null }),
}));

/** Take the draft out of the store (for a form that opens now). */
export function takeDraft(): AddByHandDraft | null {
  const { draft, clear } = useDraftStore.getState();
  if (draft) clear();
  return draft;
}
